import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ThumbsDown"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.07 15.75C21.5694 15.5926 22.6574 14.2494 22.5 12.75V8.25C22.5 5.5125 21.33 2.25 15.75 2.25H1.5V12.75H6.345L9 16.7775L9.75 21.5325V21.6225C9.86595 22.1251 10.3069 22.4859 10.8225 22.5H12C12.1893 22.5225 12.3807 22.5225 12.57 22.5C14.0694 22.3426 15.1574 20.9994 15 19.5V15.75H19.5C19.6893 15.7725 19.8807 15.7725 20.07 15.75ZM6 11.25H3V3.75H6V11.25ZM21 12.75C21 13.83 20.58 14.25 19.5 14.25H13.5V19.5C13.5 20.58 13.08 21 12 21H11.1525L11.0475 20.25L10.5 16.2225L7.5 11.775V3.75H15.75C19.335 3.75 21 5.1825 21 8.25V12.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ThumbsDown.vue"]]);
